/** Companion-local keys. Sync token / account reuse the desk keys. */
export const COMPANION_CREW_KEY = "ns.companion.crewId";
export const COMPANION_CHROME_KEY = "ns.companion.chrome";
export const COMPANION_SNAPSHOT_KEY = "ns.companion.snapshot";
/** Owner of the cached snapshot — must match the signed-in Nanode account. */
export const COMPANION_SNAPSHOT_ACCOUNT_KEY = "ns.companion.snapshotAccountId";

/**
 * Ops Nanode hint only — paste into Settings, do not treat as a secret
 * or as the only allowed host. Saved URL stays whatever the crew enters.
 */
export const NANODE_SYNC_HINT_URL = "http://172.105.102.204:8787";

/** User-visible product name. Package path stays `apps/companion`. */
export const COMPANION_PRODUCT = "Northstar Dispatch Mobile";
/** Home-screen / install short label (manifest `short_name`, apple-mobile-web-app-title). */
export const COMPANION_PRODUCT_SHORT = "Dispatch Mobile";
export const COMPANION_SCOPE =
  "Crew snapshot (schedule, live flight tracker, weather brief, flight-affecting NOTAMs). Dispatcher can cancel or edit STD on the Nanode company board. Pilot stays assigned-only. Does not generate RFQs, write Inbox, or replace PSTN dispatch.";
